import { ISelectorData } from '../../components/application/NewApplication';
import { TFunction } from 'react-i18next';
import { ILists } from '../../interfaces/merchant';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { BUSINESS_FORM_FIELDS, BUSINESS_FORM_FIELDS_NAMES } from './business-form';

interface IBusinessInformationInputsProps {
  partnerList?: ISelectorData[];
  integrationPartnersListSelector?: ISelectorData[];
  salesAgencyListSelector?: ISelectorData[];
  accountListSelector?: ISelectorData[];
  mccList: ISelectorData[];
  lists: ILists;
  t: TFunction;
  data: any;
  authUser?: any;
}

export const SUPER_ADMIN_BUSINESS_INFORMATION_INPUTS = ({ partnerList, integrationPartnersListSelector, salesAgencyListSelector, lists, t, mccList, accountListSelector, data, authUser }: IBusinessInformationInputsProps): IFormInputProps[] => [
  {
    key: BUSINESS_FORM_FIELDS.COMPANY_NAME,
    fieldName: BUSINESS_FORM_FIELDS.COMPANY_NAME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.COMPANY_NAME)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.COMPANY_NAME),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.DOING_BUSINESS,
    fieldName: BUSINESS_FORM_FIELDS.DOING_BUSINESS,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DOING_BUSINESS)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.DOING_BUSINESS),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.TAX,
    fieldName: BUSINESS_FORM_FIELDS.TAX,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.TAX)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.TAX),
    inputType: InputType.Text,
    // required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.INDUSTRY,
    fieldName: BUSINESS_FORM_FIELDS.INDUSTRY,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.INDUSTRY),
    label: t(BUSINESS_FORM_FIELDS_NAMES.INDUSTRY),
    inputType: InputType.Select,
    // required: true,
    data: lists.industries,
    dataCy: 'industry',
    placement: 'bottomEnd'
  },
  // {
  //   key: BUSINESS_FORM_FIELDS.ANNUAL_SALES_VOLUME,
  //   fieldName: BUSINESS_FORM_FIELDS.ANNUAL_SALES_VOLUME,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.ANNUAL_SALES_VOLUME)}`,
  //   label: t(BUSINESS_FORM_FIELDS_NAMES.ANNUAL_SALES_VOLUME),
  //   inputType: InputType.Number,
  //   required: true,
  //   autoComplete: 'off',
  //   prefix: '$',
  //   // suffix: 'USD',
  //   useNumberFormatter: true,
  //   shouldFormat: true,
  // },
  // {
  //   key: BUSINESS_FORM_FIELDS.DECLINE_RATE,
  //   fieldName: BUSINESS_FORM_FIELDS.DECLINE_RATE,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DECLINE_RATE)}`,
  //   label: t(BUSINESS_FORM_FIELDS_NAMES.DECLINE_RATE),
  //   inputType: InputType.Number,
  //   required: false,
  //   autoComplete: 'off',
  //   suffix: '%',
  //   min: 0,
  //   max: 100,
  // },
  // {
  //   key: BUSINESS_FORM_FIELDS.DECLINE_RECOVERY_BASELINE,
  //   fieldName: BUSINESS_FORM_FIELDS.DECLINE_RECOVERY_BASELINE,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DECLINE_RECOVERY_BASELINE)}`,
  //   label: t(BUSINESS_FORM_FIELDS_NAMES.DECLINE_RECOVERY_BASELINE),
  //   inputType: InputType.Number,
  //   required: false,
  //   autoComplete: 'off',
  //   suffix: '%',
  //   min: 0,
  //   max: 100,
  // },

  {
    key: BUSINESS_FORM_FIELDS.ACCOUNT_ID,
    fieldName: BUSINESS_FORM_FIELDS.ACCOUNT_ID,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.ACCOUNT_ID),
    label: t(BUSINESS_FORM_FIELDS_NAMES.ACCOUNT_ID),
    inputType: InputType.Select,
    // required: false,
    // enableCreateNew: true,
    data: accountListSelector,
    disabled: data?.accountId
  },
  {
    key: BUSINESS_FORM_FIELDS.PARTNER_ID,
    fieldName: BUSINESS_FORM_FIELDS.PARTNER_ID,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.PARTNER_ID),
    label: t(BUSINESS_FORM_FIELDS_NAMES.PARTNER_ID),
    inputType: InputType.Select,
    required: true,
    // enableCreateNew: true,
    data: partnerList,
    // TODO check partners permissions
    disabled: checkRoles(authUser, CLAIMS.PARTNER_ADMIN) || checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN),
  },
  {
    key: BUSINESS_FORM_FIELDS.INTEGRATION_PARTNER,
    fieldName: BUSINESS_FORM_FIELDS.INTEGRATION_PARTNER,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    label: t(BUSINESS_FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    inputType: InputType.Select,
    // required: false,
    // enableCreateNew: true,
    data: integrationPartnersListSelector,
  },
  {
    key: BUSINESS_FORM_FIELDS.SALES_AGENCY_ID,
    fieldName: BUSINESS_FORM_FIELDS.SALES_AGENCY_ID,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.SALES_AGENCY_ID),
    label: t(BUSINESS_FORM_FIELDS_NAMES.SALES_AGENCY_ID),
    inputType: InputType.Select,
    // required: false,
    // enableCreateNew: true,
    data: salesAgencyListSelector,
    // TODO check partners permissions
    disabled: checkRoles(authUser, CLAIMS.PARTNER_ADMIN) || checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN)
  },
  {
    key: BUSINESS_FORM_FIELDS.BUSINESS_TYPE,
    fieldName: BUSINESS_FORM_FIELDS.BUSINESS_TYPE,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.BUSINESS_TYPE),
    label: t(BUSINESS_FORM_FIELDS_NAMES.BUSINESS_TYPE),
    inputType: InputType.Select,
    // required: true,
    dataCy: 'business_type',
    data: lists.businessTypes,
  },
  {
    key: BUSINESS_FORM_FIELDS.PLATFORM,
    fieldName: BUSINESS_FORM_FIELDS.PLATFORM,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.PLATFORM),
    label: t(BUSINESS_FORM_FIELDS_NAMES.PLATFORM),
    inputType: InputType.Select,
    // required: false,
    data: lists.ecommercePlatforms,
    dataCy: 'platform',
    placement: 'bottomEnd',
  },
  {
    key: BUSINESS_FORM_FIELDS.PRODUCTS_SOLD,
    fieldName: BUSINESS_FORM_FIELDS.PRODUCTS_SOLD,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.PRODUCTS_SOLD),
    label: t(BUSINESS_FORM_FIELDS_NAMES.PRODUCTS_SOLD),
    inputType: InputType.Select,
    // required: false,
    data: lists.productSoldFields,
    dataCy: 'productSoldFields',
    placement: 'bottomEnd',
  },
  {
    key: BUSINESS_FORM_FIELDS.MCC,
    fieldName: BUSINESS_FORM_FIELDS.MCC,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.MCC),
    label: t(BUSINESS_FORM_FIELDS_NAMES.MCC),
    inputType: InputType.Select,
    required: true,
    // route: HELPERS_ROUTES.MCC,
    data: mccList,
    // isTooltip: true,
    dataCy: 'mcc',
  },
  {
    key: BUSINESS_FORM_FIELDS.DESCRIPTOR,
    fieldName: BUSINESS_FORM_FIELDS.DESCRIPTOR,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DESCRIPTOR)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.DESCRIPTOR),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.BUSINESS_ESTABLISHED_DATE,
    fieldName: BUSINESS_FORM_FIELDS.BUSINESS_ESTABLISHED_DATE,
    label: t(BUSINESS_FORM_FIELDS_NAMES.BUSINESS_ESTABLISHED_DATE),
    inputType: InputType.Date,
    // required: false,
  },
  // {
  //   key: BUSINESS_FORM_FIELDS.WEB_URL,
  //   fieldName: BUSINESS_FORM_FIELDS.WEB_URL,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.WEB_URL)}`,
  //   label: t(BUSINESS_FORM_FIELDS_NAMES.WEB_URL),
  //   inputType: InputType.Text,
  //   required: true,
  //   isTooltip: true,
  // },
];

export const PARTNERS_BUSINESS_INFORMATION_INPUTS = ({ integrationPartnersListSelector, lists, t, mccList, accountListSelector, data }: IBusinessInformationInputsProps): IFormInputProps[] => [
  {
    key: BUSINESS_FORM_FIELDS.COMPANY_NAME,
    fieldName: BUSINESS_FORM_FIELDS.COMPANY_NAME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.COMPANY_NAME)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.COMPANY_NAME),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.DOING_BUSINESS,
    fieldName: BUSINESS_FORM_FIELDS.DOING_BUSINESS,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DOING_BUSINESS)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.DOING_BUSINESS),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.ANNUAL_SALES_VOLUME,
    fieldName: BUSINESS_FORM_FIELDS.ANNUAL_SALES_VOLUME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.ANNUAL_SALES_VOLUME)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.ANNUAL_SALES_VOLUME),
    inputType: InputType.Number,
    required: true,
    autoComplete: 'off',
    prefix: '$',
    useNumberFormatter: true,
    shouldFormat: true,
  },
    {
        key: BUSINESS_FORM_FIELDS.DECLINE_RATE,
        fieldName: BUSINESS_FORM_FIELDS.DECLINE_RATE,
        placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DECLINE_RATE)}`,
        label: t(BUSINESS_FORM_FIELDS_NAMES.DECLINE_RATE),
        inputType: InputType.Number,
        required: false,
        autoComplete: 'off',
        suffix: '%',
        min: 0,
        max: 100,
    },
  {
    key: BUSINESS_FORM_FIELDS.TAX,
    fieldName: BUSINESS_FORM_FIELDS.TAX,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.TAX)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.TAX),
    inputType: InputType.Text,
    // required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.INDUSTRY,
    fieldName: BUSINESS_FORM_FIELDS.INDUSTRY,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.INDUSTRY),
    label: t(BUSINESS_FORM_FIELDS_NAMES.INDUSTRY),
    inputType: InputType.Select,
    // required: true,
    data: lists.industries,
    dataCy: 'industry',
    placement: 'bottomEnd'
  },
  {
    key: BUSINESS_FORM_FIELDS.ACCOUNT_ID,
    fieldName: BUSINESS_FORM_FIELDS.ACCOUNT_ID,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.ACCOUNT_ID),
    label: t(BUSINESS_FORM_FIELDS_NAMES.ACCOUNT_ID),
    inputType: InputType.Select,
    // required: false,
    // enableCreateNew: true,
    data: accountListSelector,
    disabled: data?.accountId
  },
  // {
  //   key: BUSINESS_FORM_FIELDS.PARTNER_ID,
  //   fieldName: BUSINESS_FORM_FIELDS.PARTNER_ID,
  //   placeholder: t(BUSINESS_FORM_FIELDS_NAMES.PARTNER_ID),
  //   label: t(BUSINESS_FORM_FIELDS_NAMES.PARTNER_ID),
  //   inputType: InputType.Select,
  //   required: true,
  //   // enableCreateNew: true,
  //   data: partnerList,
  //   disabled: checkRoles(authUser, CLAIMS.PARTNER_ADMIN),
  // },
  {
    key: BUSINESS_FORM_FIELDS.INTEGRATION_PARTNER,
    fieldName: BUSINESS_FORM_FIELDS.INTEGRATION_PARTNER,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    label: t(BUSINESS_FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    inputType: InputType.Select,
    // required: false,
    // enableCreateNew: true,
    data: integrationPartnersListSelector,
  },
  // {
  //   key: BUSINESS_FORM_FIELDS.SALES_AGENCY_ID,
  //   fieldName: BUSINESS_FORM_FIELDS.SALES_AGENCY_ID,
  //   placeholder: t(BUSINESS_FORM_FIELDS_NAMES.SALES_AGENCY_ID),
  //   label: t(BUSINESS_FORM_FIELDS_NAMES.SALES_AGENCY_ID),
  //   inputType: InputType.Select,
  //   // required: false,
  //   // enableCreateNew: true,
  //   data: salesAgencyListSelector,
  //   disabled: checkRoles(authUser, CLAIMS.PARTNER_ADMIN)
  // },
  {
    key: BUSINESS_FORM_FIELDS.BUSINESS_TYPE,
    fieldName: BUSINESS_FORM_FIELDS.BUSINESS_TYPE,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.BUSINESS_TYPE),
    label: t(BUSINESS_FORM_FIELDS_NAMES.BUSINESS_TYPE),
    inputType: InputType.Select,
    // required: true,
    dataCy: 'business_type',
    data: lists.businessTypes,
  },
  {
    key: BUSINESS_FORM_FIELDS.PLATFORM,
    fieldName: BUSINESS_FORM_FIELDS.PLATFORM,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.PLATFORM),
    label: t(BUSINESS_FORM_FIELDS_NAMES.PLATFORM),
    inputType: InputType.Select,
    // required: false,
    data: lists.ecommercePlatforms,
    dataCy: 'platform',
    placement: 'bottomEnd',
  },
  {
    key: BUSINESS_FORM_FIELDS.PRODUCTS_SOLD,
    fieldName: BUSINESS_FORM_FIELDS.PRODUCTS_SOLD,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.PRODUCTS_SOLD),
    label: t(BUSINESS_FORM_FIELDS_NAMES.PRODUCTS_SOLD),
    inputType: InputType.Select,
    searchable: false,
    data: lists.productSoldFields,
    dataCy: 'productSoldFields',
    placement: 'bottomEnd',
  },
  {
    key: BUSINESS_FORM_FIELDS.MCC,
    fieldName: BUSINESS_FORM_FIELDS.MCC,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.MCC),
    label: t(BUSINESS_FORM_FIELDS_NAMES.MCC),
    inputType: InputType.Select,
    required: true,
    // route: HELPERS_ROUTES.MCC,
    data: mccList,
    // isTooltip: true,
    dataCy: 'mcc',
  },
  {
    key: BUSINESS_FORM_FIELDS.DESCRIPTOR,
    fieldName: BUSINESS_FORM_FIELDS.DESCRIPTOR,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DESCRIPTOR)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.DESCRIPTOR),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.BUSINESS_ESTABLISHED_DATE,
    fieldName: BUSINESS_FORM_FIELDS.BUSINESS_ESTABLISHED_DATE,
    label: t(BUSINESS_FORM_FIELDS_NAMES.BUSINESS_ESTABLISHED_DATE),
    inputType: InputType.Date,
    // required: false,
  },
  // {
  //   key: BUSINESS_FORM_FIELDS.WEB_URL,
  //   fieldName: BUSINESS_FORM_FIELDS.WEB_URL,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.WEB_URL)}`,
  //   label: t(BUSINESS_FORM_FIELDS_NAMES.WEB_URL),
  //   inputType: InputType.Text,
  //   required: true,
  //   isTooltip: true,
  // },
];

export const INTEGRATION_PARTNER_BUSINESS_INFORMATION_INPUTS = ({ lists, t, mccList, accountListSelector, data }: IBusinessInformationInputsProps): IFormInputProps[] => [
  {
    key: BUSINESS_FORM_FIELDS.COMPANY_NAME,
    fieldName: BUSINESS_FORM_FIELDS.COMPANY_NAME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.COMPANY_NAME)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.COMPANY_NAME),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.DOING_BUSINESS,
    fieldName: BUSINESS_FORM_FIELDS.DOING_BUSINESS,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DOING_BUSINESS)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.DOING_BUSINESS),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.TAX,
    fieldName: BUSINESS_FORM_FIELDS.TAX,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.TAX)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.TAX),
    inputType: InputType.Text,
    // required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.INDUSTRY,
    fieldName: BUSINESS_FORM_FIELDS.INDUSTRY,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.INDUSTRY),
    label: t(BUSINESS_FORM_FIELDS_NAMES.INDUSTRY),
    inputType: InputType.Select,
    // required: true,
    data: lists.industries,
    dataCy: 'industry',
    placement: 'bottomEnd'
  },
  {
    key: BUSINESS_FORM_FIELDS.ACCOUNT_ID,
    fieldName: BUSINESS_FORM_FIELDS.ACCOUNT_ID,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.ACCOUNT_ID),
    label: t(BUSINESS_FORM_FIELDS_NAMES.ACCOUNT_ID),
    inputType: InputType.Select,
    data: accountListSelector,
    disabled: data?.accountId
  },
  {
    key: BUSINESS_FORM_FIELDS.BUSINESS_TYPE,
    fieldName: BUSINESS_FORM_FIELDS.BUSINESS_TYPE,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.BUSINESS_TYPE),
    label: t(BUSINESS_FORM_FIELDS_NAMES.BUSINESS_TYPE),
    inputType: InputType.Select,
    // required: true,
    dataCy: 'business_type',
    data: lists.businessTypes,
  },
  {
    key: BUSINESS_FORM_FIELDS.PLATFORM,
    fieldName: BUSINESS_FORM_FIELDS.PLATFORM,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.PLATFORM),
    label: t(BUSINESS_FORM_FIELDS_NAMES.PLATFORM),
    inputType: InputType.Select,
    // required: false,
    data: lists.ecommercePlatforms,
    dataCy: 'platform',
    placement: 'bottomEnd',
  },
  {
    key: BUSINESS_FORM_FIELDS.PRODUCTS_SOLD,
    fieldName: BUSINESS_FORM_FIELDS.PRODUCTS_SOLD,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.PRODUCTS_SOLD),
    label: t(BUSINESS_FORM_FIELDS_NAMES.PRODUCTS_SOLD),
    inputType: InputType.Select,
    searchable: false,
    data: lists.productSoldFields,
    dataCy: 'productSoldFields',
    placement: 'bottomEnd',
  },
  {
    key: BUSINESS_FORM_FIELDS.MCC,
    fieldName: BUSINESS_FORM_FIELDS.MCC,
    placeholder: t(BUSINESS_FORM_FIELDS_NAMES.MCC),
    label: t(BUSINESS_FORM_FIELDS_NAMES.MCC),
    inputType: InputType.Select,
    required: true,
    // route: HELPERS_ROUTES.MCC,
    data: mccList,
    // isTooltip: true,
    dataCy: 'mcc',
  },
  {
    key: BUSINESS_FORM_FIELDS.DESCRIPTOR,
    fieldName: BUSINESS_FORM_FIELDS.DESCRIPTOR,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DESCRIPTOR)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.DESCRIPTOR),
    inputType: InputType.Text,
    required: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.BUSINESS_ESTABLISHED_DATE,
    fieldName: BUSINESS_FORM_FIELDS.BUSINESS_ESTABLISHED_DATE,
    label: t(BUSINESS_FORM_FIELDS_NAMES.BUSINESS_ESTABLISHED_DATE),
    inputType: InputType.Date,
    // required: false,
  },
];

export const BUSINESS_METRICS_INPUTS = ({ t }: { t: any }): IFormInputProps[] => [
  {
    key: BUSINESS_FORM_FIELDS.ANNUAL_SALES_VOLUME,
    fieldName: BUSINESS_FORM_FIELDS.ANNUAL_SALES_VOLUME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.ANNUAL_SALES_VOLUME)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.ANNUAL_SALES_VOLUME),
    inputType: InputType.Number,
    required: true,
    autoComplete: 'off',
    prefix: '$',
    // suffix: 'USD',
    useNumberFormatter: true,
    shouldFormat: true,
  },
  {
    key: BUSINESS_FORM_FIELDS.DECLINE_RATE,
    fieldName: BUSINESS_FORM_FIELDS.DECLINE_RATE,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DECLINE_RATE)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.DECLINE_RATE),
    inputType: InputType.Number,
    required: false,
    autoComplete: 'off',
    suffix: '%',
    min: 0,
    max: 100,
  },
  {
    key: BUSINESS_FORM_FIELDS.DECLINE_RECOVERY_BASELINE,
    fieldName: BUSINESS_FORM_FIELDS.DECLINE_RECOVERY_BASELINE,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_FORM_FIELDS_NAMES.DECLINE_RECOVERY_BASELINE)}`,
    label: t(BUSINESS_FORM_FIELDS_NAMES.DECLINE_RECOVERY_BASELINE),
    inputType: InputType.Number,
    required: false,
    autoComplete: 'off',
    suffix: '%',
    min: 0,
    max: 100,
  },
];


